export default {
  text: 'Kortet leveres af Google. Når det indlæses, sendes din IP-adresse til Google.',
  buttons: {
    show_map: 'Vis kort',
    retry: 'Prøv igen',
  },
  errors: {
    map_unavailable: 'Kortet kunne ikke indlæses.',
  },
};
